import React, { useState } from 'react';
import { UserIcon, PencilRulerIcon, CalendarIcon, EyeIcon, EditIcon, DownloadIcon, ShareIcon, RulerIcon, PieChartIcon, DropletIcon, TagIcon, ChevronRightIcon, ChevronLeftIcon, ListIcon, LayoutGridIcon, FoldersIcon } from 'lucide-react';
import { FolderView } from './FolderView';
// Mock data for shared designs
const sharedDesignsData = [{
  id: 'SD001',
  name: 'North Valley Project',
  description: 'Shared by AiscoEurope SAU',
  date: 'Aug 10, 2025',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 2,
  specs: {
    length: '300.00 m',
    angle: '360°',
    area: '35.00 ha',
    flow: '38.50 l/s',
    pressure: '2.20 bar'
  },
  sharedBy: 'Daniel Fernández',
  sharedDate: '2025-08-10',
  tags: ['Multi-Pivot', 'Valley']
}, {
  id: 'SD002',
  name: 'Riverside Linear Setup',
  description: 'Shared by HMB Irrigation',
  date: 'Jul 25, 2025',
  status: 'completed',
  model: 'Linear',
  pivotCount: 1,
  specs: {
    length: '350.00 m',
    angle: 'N/A',
    area: '40.00 ha',
    flow: '45.00 l/s',
    pressure: '2.50 bar'
  },
  sharedBy: 'Benny Ginter',
  sharedDate: '2025-07-25',
  tags: ['Linear', 'Riverside']
}];
export function SharedDesigns({
  searchQuery,
  selectedDealer,
  selectedRegion,
  selectedModel
}) {
  const [viewType, setViewType] = useState('grid'); // 'grid', 'list', or 'folders'
  // Filter designs based on search query and model
  const filteredDesigns = sharedDesignsData.filter(design => {
    const matchesSearch = searchQuery === '' || design.id.toLowerCase().includes(searchQuery.toLowerCase()) || design.name.toLowerCase().includes(searchQuery.toLowerCase()) || design.description.toLowerCase().includes(searchQuery.toLowerCase()) || design.sharedBy.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesModel = selectedModel === 'all' || design.model.toLowerCase().includes(selectedModel.toLowerCase());
    return matchesSearch && matchesModel;
  });
  const handleViewDesign = design => {
    console.log('Viewing design:', design);
    // Aquí implementarías la lógica para ver un diseño
  };
  return <div data-id="element-3034" data-mp="rjy2qpzq2pk">
      {/* Dashboard summary */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 border-b border-gray-200 bg-gray-50" data-id="element-3035" data-mp="td4c4woykx1">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-3036" data-mp="3i9v01hs5k2sk">
          <div className="flex justify-between items-start" data-id="element-3037" data-mp="3n869hrejcba9">
            <div data-id="element-3038" data-mp="eruojsne1fa7">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-3039" data-mp="erbhx836udbh">
                Shared With Me
              </h3>
              <p className="text-4xl font-bold text-indigo-600" data-id="element-3040" data-mp="jpd0lrwpcamf">
                {filteredDesigns.length}
              </p>
            </div>
            <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-3041" data-mp="4vrjof15j2jk">
              <ShareIcon size={24} className="text-indigo-600" data-id="element-3042" data-mp="9r711gydbgkq" />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-600" data-id="element-3043" data-mp="2piuvn5pwsx0d">
            From {new Set(filteredDesigns.map(d => d.sharedBy)).size}{' '}
            collaborators
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-3044" data-mp="1ck1ckjfgrhwx">
          <div className="flex justify-between items-start" data-id="element-3045" data-mp="17mj1amdz4qlr">
            <div data-id="element-3046" data-mp="17odmm1t5qkqd">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-3047" data-mp="1lliorqpr2zgc">
                Shared By
              </h3>
              <div className="mt-2" data-id="element-3048" data-mp="1hjnrcxaxx67u">
                {Array.from(new Set(filteredDesigns.map(d => d.sharedBy))).map((person, index) => <div key={index} className="flex justify-between text-sm mb-1" data-id="element-3049" data-mp="tvnynru2j5qm" data-mpi={index}>
                    <span data-id="element-3050" data-mp="owb1ad5kmg9s">{person}</span>
                    <span className="font-medium" data-id="element-3051" data-mp="oxcqdljf93ai">
                      {filteredDesigns.filter(d => d.sharedBy === person).length}
                    </span>
                  </div>)}
              </div>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg" data-id="element-3052" data-mp="xuda3evjqd7m">
              <UserIcon size={24} className="text-blue-600" data-id="element-3053" data-mp="a5au0bgk8sf8" />
            </div>
          </div>
        </div>
      </div>

      {/* View type toggle */}
      <div className="flex justify-between items-center px-6 py-3 bg-white border-b border-gray-200" data-id="element-3054" data-mp="iu9gob9nv7kh">
        <div className="text-gray-700 font-medium" data-id="element-3055" data-mp="ntcbl2vxfxeq">
          {filteredDesigns.length} shared designs
        </div>
        <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-3056" data-mp="srx9gvnpi500">
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'list' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('list')} data-id="element-3057" data-mp="xj5l7ycie2gc">
            <ListIcon size={16} className="mr-1" data-id="element-3058" data-mp="12kbepydzttqx" />
            List
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'grid' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('grid')} data-id="element-3059" data-mp="16i0sldrahil8">
            <LayoutGridIcon size={16} className="mr-1" data-id="element-3060" data-mp="1ggoyje60278k" />
            Grid
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'folders' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('folders')} data-id="element-3061" data-mp="3dbbl198ox7g1">
            <FoldersIcon size={16} className="mr-1" data-id="element-3062" data-mp="3aq3tjxlvj20v" />
            Folders
          </button>
        </div>
      </div>

      {/* Designs view (grid, list, or folders) */}
      {viewType === 'folders' ? <div className="h-[calc(100vh-400px)] min-h-[400px]" data-id="element-3063" data-mp="30ziuya679xhy">
          <FolderView designs={filteredDesigns} onViewDesign={handleViewDesign} data-id="element-3064" data-mp="30xppgy7bpjbj" />
        </div> : viewType === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6" data-id="element-3065" data-mp="3toptva9kgp3q">
          {filteredDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-3066" data-mp="3op3iz7h7nky3" />)}
          {filteredDesigns.length === 0 && <div className="col-span-3 text-center py-12 text-gray-500" data-id="element-3067" data-mp="3jqa358egbhur">
              No shared designs found matching your search criteria
            </div>}
        </div> : <div className="overflow-x-auto" data-id="element-3068" data-mp="3er75wa4pqfxc">
          <table className="w-full" data-id="element-3069" data-mp="28bwjygun7ql2">
            <thead className="bg-gray-50" data-id="element-3070" data-mp="28cy8no4l0bl9">
              <tr data-id="element-3071" data-mp="23ca7i9mn2edb">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3072" data-mp="23bsahas5jw4c">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3073" data-mp="vaqmfrdnej9b">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3074" data-mp="ldlxxkwbybpc">
                  Shared By
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3075" data-mp="bovo5mv1tjfs">
                  Model
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3076" data-mp="gh5akswyg1db">
                  Specs
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3077" data-mp="7n0m2g5an20y">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3078" data-mp="3ow5qkoix7jko">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-3079" data-mp="3a8yoz9fbrxyg">
              {filteredDesigns.map(design => <tr key={design.id} className="hover:bg-gray-50" data-id="element-3080" data-mp="368wnb09lb4j6">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-3081" data-mp="3k7wb65pa3fea">
                    {design.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-3082" data-mp="3fa4j9bomvta3">
                    <div className="font-medium" data-id="element-3083" data-mp="3t5gdzj2shjr0">{design.name}</div>
                    <div className="text-gray-500 text-xs" data-id="element-3084" data-mp="3p569kaunb1e9">
                      {design.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-3085" data-mp="1svhb3o7q9a4">
                    <div className="flex items-center" data-id="element-3086" data-mp="1uyfiazir8px">
                      <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center mr-2" data-id="element-3087" data-mp="gr7dzabl5i1a">
                        <UserIcon size={16} className="text-indigo-600" data-id="element-3088" data-mp="bsmcz8oieubs" />
                      </div>
                      <div data-id="element-3089" data-mp="2sjl91g7wfmvq">
                        {design.sharedBy}
                        <div className="text-xs text-gray-500" data-id="element-3090" data-mp="2xieovfanrpz2">
                          {design.date}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-3091" data-mp="37gcdw50cdqsq">
                    <div className="flex items-center" data-id="element-3092" data-mp="29ueororgin7t">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-8 mr-2" data-id="element-3093" data-mp="29rsh7p4kg7pl" />
                      <div data-id="element-3094" data-mp="2jr198cfvfc9b">
                        {design.model}
                        <div className="text-xs text-gray-500" data-id="element-3095" data-mp="2oj1emkepmxda">
                          {design.pivotCount}{' '}
                          {design.pivotCount === 1 ? 'unit' : 'units'}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-3096" data-mp="d6u8p7eqpflc">
                    <div className="flex gap-2 text-xs" data-id="element-3097" data-mp="95itzwxemerx">
                      <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-3098" data-mp="960mcigy48uk">
                        {design.specs.length}
                      </span>
                      <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-3099" data-mp="3vd8nt9oqvvlb">
                        {design.specs.area}
                      </span>
                      <span className="bg-teal-50 text-teal-700 px-2 py-0.5 rounded-full" data-id="element-3100" data-mp="3qfgy8mbkolka">
                        {design.specs.flow}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-3101" data-mp="3cm7mwg42dpz4">
                    <StatusBadge status={design.status} data-id="element-3102" data-mp="3co2cw8u708a2" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-3103" data-mp="37lthl5tuku4s">
                    <div className="flex space-x-2" data-id="element-3104" data-mp="32p31iii1lyjd">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-3105" data-mp="32qe6umr4zecl">
                        <EyeIcon size={16} data-id="element-3106" data-mp="252dn85q3vyrr" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-3107" data-mp="204c2lgd17re6">
                        <EditIcon size={16} data-id="element-3108" data-mp="2dwry7w3lsn52" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-3109" data-mp="29uwwiqhrg7qr">
                        <ShareIcon size={16} data-id="element-3110" data-mp="29x1a605gol48" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {filteredDesigns.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-3111" data-mp="1v60t56qnfiwh">
              No shared designs found matching your search criteria
            </div>}
        </div>}
    </div>;
}
// Helper component for design cards
function DesignCard({
  design
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'active':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'pending':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-3112" data-mp="305yyid1fbpn0">
      <div className="p-5 border-b border-gray-100" data-id="element-3113" data-mp="3564olos1p42z">
        <div className="flex justify-between items-start" data-id="element-3114" data-mp="3suntdubvyyqb">
          <div data-id="element-3115" data-mp="1nbly70t1znl">
            <div className="flex items-center" data-id="element-3116" data-mp="1nth10bqe7tx">
              <h3 className="font-bold text-gray-900 truncate max-w-[200px]" data-id="element-3117" data-mp="1mic2x6juu18">
                {design.name}
              </h3>
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-3118" data-mp="3o2wdcdqcwbef">
                {design.id}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1" data-id="element-3119" data-mp="fli32bhjbl0k">{design.description}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(design.status)}`} data-id="element-3120" data-mp="kekuoe2r4ke4">
            {design.status.charAt(0).toUpperCase() + design.status.slice(1)}
          </span>
        </div>
        <div className="mt-4 flex items-center" data-id="element-3121" data-mp="pbhwvdxirqcc">
          <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center mr-2" data-id="element-3122" data-mp="kb2l2qsvyqwh">
            <UserIcon size={16} className="text-indigo-600" data-id="element-3123" data-mp="gajsuvn2zitr" />
          </div>
          <div data-id="element-3124" data-mp="baxfmm7962ky">
            <div className="text-sm font-medium text-gray-900" data-id="element-3125" data-mp="bbfk2642jn3y">
              Shared by: {design.sharedBy}
            </div>
            <div className="text-xs text-gray-500 flex items-center" data-id="element-3126" data-mp="6j5vateowt39">
              <CalendarIcon size={10} className="mr-1" data-id="element-3127" data-mp="1kkw8xb6cfge" />
              {design.date}
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4 flex justify-between items-center bg-gray-50 border-b border-gray-100" data-id="element-3128" data-mp="3st04pldakxcr">
        <div className="flex items-center" data-id="element-3129" data-mp="3opafctosmbqo">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-12 mr-3" data-id="element-3130" data-mp="3jqza6w9g0pes" />
          <div data-id="element-3131" data-mp="1z86ojpaozowq">
            <div className="text-sm font-medium text-gray-900" data-id="element-3132" data-mp="1zasrfbmn1g8m">
              {design.model}
            </div>
            <div className="text-xs text-gray-500" data-id="element-3133" data-mp="249m451u3p37q">
              {design.pivotCount} {design.pivotCount === 1 ? 'unit' : 'units'}
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4" data-id="element-3134" data-mp="2d6d963qmrseg">
        <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-3135" data-mp="1giqjcoo2b89z">
          SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-3 gap-2" data-id="element-3136" data-mp="1kjagvtcjsdwn">
          <div className="bg-blue-50 rounded-lg p-2 text-center" data-id="element-3137" data-mp="1kk2004oykj61">
            <div className="text-xs text-blue-600 mb-1 flex items-center justify-center" data-id="element-3138" data-mp="1phu2fsn8bnoh">
              <RulerIcon size={12} className="mr-1" data-id="element-3139" data-mp="1u9v9n05jio7n" />
              Length
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3140" data-mp="wuzlh5pmf6fr">
              {design.specs.length}
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-2 text-center" data-id="element-3141" data-mp="11rq1xu5c841p">
            <div className="text-xs text-indigo-600 mb-1 flex items-center justify-center" data-id="element-3142" data-mp="34f6hmfpf9kyc">
              <PieChartIcon size={12} className="mr-1" data-id="element-3143" data-mp="2zhem7bpkjgpe" />
              Area
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3144" data-mp="3d8t9huqie429">
              {design.specs.area}
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-2 text-center" data-id="element-3145" data-mp="38grptnr0hb27">
            <div className="text-xs text-teal-600 mb-1 flex items-center justify-center" data-id="element-3146" data-mp="3n5xwtxw3c5kn">
              <DropletIcon size={12} className="mr-1" data-id="element-3147" data-mp="3i7mm7kxz1r1d" />
              Flow
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3148" data-mp="1rfa7ntel28">
              {design.specs.flow}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1" data-id="element-3149" data-mp="3s6vf0ah3ozm5">
          {design.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-3150" data-mp="21scs3vve9dcr" data-mpi={index}>
              <TagIcon size={10} className="mr-1" data-id="element-3151" data-mp="1xt3w0kcvt3e1" />
              {tag}
            </span>)}
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-100 flex justify-between" data-id="element-3152" data-mp="1nodziu08yrh7">
        <div className="flex space-x-2" data-id="element-3153" data-mp="1rnwd14pqo0a0">
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-3154" data-mp="1dxsuanq2iopb">
            <EyeIcon size={14} className="mr-1" data-id="element-3155" data-mp="1iwvzq99ymwxt" />
            View
          </button>
          <button className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center" data-id="element-3156" data-mp="1iuj814eeh87k">
            <EditIcon size={14} className="mr-1" data-id="element-3157" data-mp="141y5tbz5xzem" />
            Edit
          </button>
        </div>
        <div className="flex space-x-2" data-id="element-3158" data-mp="18wbwx26slkdh">
          <button className="text-gray-600 hover:text-gray-800" data-id="element-3159" data-mp="uzyosjo5evbo">
            <ShareIcon size={16} data-id="element-3160" data-mp="zy0917xb90oq" />
          </button>
          <button className="text-gray-600 hover:text-gray-800" data-id="element-3161" data-mp="zyjpslb85j16">
            <DownloadIcon size={16} data-id="element-3162" data-mp="2pceof1mfvb7k" />
          </button>
        </div>
      </div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    text: 'Unknown'
  };
  switch (status) {
    case 'active':
      config = {
        color: 'blue',
        text: 'Active'
      };
      break;
    case 'completed':
      config = {
        color: 'green',
        text: 'Completed'
      };
      break;
    case 'pending':
      config = {
        color: 'amber',
        text: 'Pending'
      };
      break;
  }
  const colors = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    amber: 'bg-amber-100 text-amber-800',
    gray: 'bg-gray-100 text-gray-800'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[config.color]}`} data-id="element-3163" data-mp="36omqantkbkli">
      {config.text}
    </span>;
}